import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import { Pagination } from "antd";
import { connect } from "react-redux";
import { processJonham } from "../helpers";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { setViewData } from "../actions/viewDataAction";

const markHighLight = (str, keyword) => {
  const patt = new RegExp(keyword, "g");
  if (str != "" && str !== null && str !== undefined && keyword !== "") {
    return str.replace(patt, `<mark>${keyword}</mark>`);
  } else if (keyword !== "" && (str === null || str === undefined)) {
    return "";
  } else if (keyword === "" && (str === null || str === undefined)) {
    return "";
  } else if (keyword === "") {
    return str;
  }
};

const List = ({ search, labels, language, setViewData }) => {
  const [current, setCurrent] = useState(1);
  const [items, setItems] = useState({ marks: [], designs: [], origins: [] });

  const {
    tmNameLabel,
    categoryLabel,
    designNameLabel,
    rOrgLabel,
    rNumberLabel,
    rDateLabel,
    ownerAddressLabel,
    originNameLabel,
    descLabel,
    resultLabel,
  } = labels;
  let lang = "";
  if (language == 0) lang = "Kp";
  if (language == 1) lang = "En";
  if (language == 2) lang = "Cn";
  if (language == 3) lang = "Ru";

  useEffect(() => {
    if (search != "")
      axios
        .get(`/api/home`, { params: { search, language } })
        .then((res) => {
          if (res.status == 200 && res.data) {
            setItems(res.data);
          }
        })
        .catch();
  }, [search]);

  let renderItems = [];

  let count = 0;
  let start = current * 5 - 4;
  let end = current * 5;

  for (let i = 0; i < items.marks.length; i++) {
    count++;
    if (count < start || count > end) continue;

    let item = items.marks[i];
    renderItems.push(
      <Link to="/view" onClick={() => setViewData("mark", item)}>
        <a
          href="#"
          class="list-group-item d-flex flex-wrap align-items-center over-shadow"
        >
          <img
            style={{ width: "100px", height: "100px", border: "1px solid" }}
            src={`uploads/trademark/${item.imageUrl}`}
            alt="dprk trademark"
          />
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${tmNameLabel[language]} : ${markHighLight(
                item[`markName${lang}`],
                search
              )}`,
            }}
          >
            {/* {tmNameLabel[language]} : {item["markNameKp"]} */}
          </span>
          {/* <span
          style={{ minWidth: "120px", margin: "0px 20px" }}
          dangerouslySetInnerHTML={{
            __html: `${categoryLabel[language]} : ${mark(
              item["kind"],
              search
            )}`,
          }}
        >
        </span> */}
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${rOrgLabel[language]} : ${markHighLight(
                item[`ownerName${lang}`],
                search
              )}`,
            }}
          ></span>
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${ownerAddressLabel[language]} : ${markHighLight(
                item[`ownerAddress${lang}`],
                search
              )}`,
            }}
          ></span>
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${rNumberLabel[language]} : ${markHighLight(
                item["regNo"],
                search
              )}`,
            }}
          >
            {/* {rNumberLabel[language]} : {item["regNo"]} */}
          </span>
          <span style={{ minWidth: "120px", margin: "0px 20px" }}>
            {rDateLabel[language]} : {moment(item.regDate).format("YYYY-MM-DD")}
          </span>
        </a>
      </Link>
    );
  }

  for (let i = 0; i < items.designs.length; i++) {
    count++;
    if (count < start || count > end) continue;

    let item = items.designs[i];
    renderItems.push(
      <Link to="/view" onClick={() => setViewData("design", item)}>
        <a
          href="#"
          class="list-group-item d-flex flex-wrap align-items-center over-shadow"
        >
          <img
            style={{ width: "100px", height: "100px", border: "1px solid" }}
            src={`uploads/design/${item.imageUrls[0]}`}
            alt="dprk trademark"
          />
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${designNameLabel[language]} : ${markHighLight(
                item[`title${lang}`],
                search
              )}`,
            }}
          >
            {/* 도안명 : {item["titleKp"]} */}
          </span>
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${rOrgLabel[language]} : ${markHighLight(
                item[`owner${lang}`],
                search
              )}`,
            }}
          >
            {/* 도안명 : {item["titleKp"]} */}
          </span>
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${categoryLabel[language]} : ${markHighLight(
                item["kind"],
                search
              )}`,
            }}
          >
            {/* 분류 : {item["kind"]} */}
          </span>

          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${rNumberLabel[language]} : ${markHighLight(
                item["regNo"],
                search
              )}`,
            }}
          >
            {/* 등록번호 : {item["regNo"]} */}
          </span>
          <span style={{ minWidth: "120px", margin: "0px 20px" }}>
            {rDateLabel[language]} : {moment(item.regDate).format("YYYY-MM-DD")}
          </span>
        </a>
      </Link>
    );
  }

  for (let i = 0; i < items.origins.length; i++) {
    count++;
    if (count < start || count > end) continue;

    let item = items.origins[i];
    renderItems.push(
      <Link to="/view" onClick={() => setViewData("origin", item)}>
        <a
          href="#"
          class="list-group-item d-flex flex-wrap align-items-center over-shadow"
        >
          <img
            style={{ width: "100px", height: "100px", border: "1px solid" }}
            src={`uploads/origin/${item.imageUrl}`}
            alt="dprk trademark"
          />
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${originNameLabel[language]} : ${markHighLight(
                item[`name${language}`],
                search
              )}`,
            }}
          >
            {/* 원산지명 : {item["nameKp"]} */}
          </span>
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${descLabel[language]} : ${markHighLight(
                item["descKp"],
                search
              )}`,
            }}
          >
            {/* 등록기관 : {item["kind"]} */}
          </span>
          <span
            style={{ minWidth: "120px", margin: "0px 20px" }}
            dangerouslySetInnerHTML={{
              __html: `${rNumberLabel[language]} : ${markHighLight(
                item["regNo"],
                search
              )}`,
            }}
          >
            {/* 등록번호 : {item["regNo"]} */}
          </span>
          <span style={{ minWidth: "120px", margin: "0px 20px" }}>
            {rDateLabel[language]} : {moment(item.regDate).format("YYYY-MM-DD")}
          </span>
        </a>
      </Link>
    );
  }

  if (search != "")
    return (
      <>
        <div className="d-flex justify-content-between pb-3">
          <div className="search-result-label">
            {language == 0 ? "자료건수" : "Result"}:&nbsp;{renderItems.length}
          </div>
          <Pagination
            defaultCurrent={1}
            total={
              items.marks.length + items.designs.length + items.origins.length
            }
            pageSize={5}
            showSizeChanger={false}
            onChange={(page) => {
              setCurrent(page);
            }}
          />
        </div>
        <ul>{renderItems.map((item, index) => item)}</ul>
      </>
    );
  else return <></>;
};

const mapStateToProps = (state) => ({
  language: state.profile.language,
  search: state.profile.search,
  labels: state.labels,
});

export default connect(mapStateToProps, { setViewData })(withRouter(List));
